import { Typography, TypographyProps } from '@mui/material';
import { styled } from '@mui/material/styles';

import { Montserrat } from 'styles/common-fonts';

export const TitleMediumStyled = styled(Typography)<TypographyProps>(() => ({
  fontFamily: Montserrat,
  fontWeight: 500,
  fontSize: '1.5rem',
}));
